/**
 * EstabelecimentosPage - Establishment registration page
 * Refactored to use extracted components
 */
import React, { useState } from 'react';
import estabelecimentoService from '../services/estabelecimentoService';
import { msg } from '../utils/messages';
import {
  EstabelecimentosSidebar,
  EstabelecimentosToolbar,
  EstabelecimentosTabs,
  DadosGeraisTab,
  LocaisContagemTab,
  RepresentantesTab,
  LocalModal,
  RepresentanteModal,
} from '../components/estabelecimentos';

type TabType = 'dados-gerais' | 'locais' | 'representantes';

// Mock data for sidebar
const mockEstabelecimentos = [
  { id: 1, nome: 'Hospital São Vicente de Paulo', codigo: 'PORTO ALEGRE - RS', numero: '25', active: true },
  { id: 2, nome: 'Hospital de Caridade de Ijuí', codigo: 'Ijuí - RS', numero: '27' },
  { id: 3, nome: 'Hospital Português', codigo: 'Porto Alegre - RS', numero: '44' },
  { id: 4, nome: 'EBSERH', codigo: 'Porto Alegre - RS', numero: '31' },
  { id: 5, nome: 'Hospital de Clínicas', codigo: 'Porto Alegre - RS', numero: '5' },
];

const EstabelecimentosPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('dados-gerais');
  const [showLocalModal, setShowLocalModal] = useState(false);
  const [showRepresentanteModal, setShowRepresentanteModal] = useState(false);

  const handleExportExcel = async () => {
    try {
      await estabelecimentoService.exportExcel(true);
      msg.success('Arquivo Excel exportado com sucesso!');
    } catch (error) {
      console.error('Erro ao exportar Excel:', error);
      msg.error('Erro ao exportar arquivo Excel');
    }
  };

  const handleSelectEstabelecimento = (id: number) => {
    console.log('Selected establishment:', id);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex">
      {/* Sidebar */}
      <EstabelecimentosSidebar
        estabelecimentos={mockEstabelecimentos}
        onSelect={handleSelectEstabelecimento}
      />

      {/* Main Area */}
      <div className="flex-1 flex flex-col">
        <EstabelecimentosToolbar onExportExcel={handleExportExcel} />
        <EstabelecimentosTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {/* Content */}
        <div className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900 p-6">
          {activeTab === 'dados-gerais' && <DadosGeraisTab />}
          {activeTab === 'locais' && (
            <LocaisContagemTab onAddLocal={() => setShowLocalModal(true)} />
          )}
          {activeTab === 'representantes' && (
            <RepresentantesTab onAddRepresentante={() => setShowRepresentanteModal(true)} />
          )}
        </div>
      </div>

      {/* Modals */}
      <LocalModal isOpen={showLocalModal} onClose={() => setShowLocalModal(false)} />
      <RepresentanteModal
        isOpen={showRepresentanteModal}
        onClose={() => setShowRepresentanteModal(false)}
      />
    </div>
  );
};

export default EstabelecimentosPage;
